import React, { useEffect, useState, useContext, useRef } from 'react';
import { timesheetService } from '../services/timesheetService';
import '../assets/css/dashboard.css';
// import { Button } from 'bootstrap';
import { descDialog } from '../compnents/dialog';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { comphelpers } from '../compnents/monthgen';
import MyContext from '../contextapi/MyContext';
import { ProgressSpinner } from 'primereact/progressspinner';
import Smallloader from '../compnents/loader';
import { loader } from '../compnents/loadermd';
import { FaBeer, FaCheck, FaEdit, FaRecycle, FaSearch } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { formatterhelper } from '../helpers/dateformatter';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Mandate } from '../compnents/formcomp';
import { Message } from 'primereact/message';
import { calculatepercent } from '../helpers/calculatepercent';

const Dashboard = () => {
   const toast = useRef(null);
   const monthyear = formatterhelper.year() + '-' + formatterhelper.monthString();

   const [isloaded, setloading] = useState(false);
   const [isgridloaded, setgridloading] = useState(false);

   const [issingleloaded, setsingleloading] = useState(false);
   const [monday, setMonday] = useState([]);
   const [days, setdays] = useState({ mon: [], tue: [], wed: [], thur: [], fri: [], sat: [], sun: [] });
   const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
   const [visible, setVisible] = useState(false);
   const [statedate, setDate] = useState('');
   const [timesheetdata, settimesheetData] = useState([]);
   const [edittoggle, setedittoggle] = useState(false);

   const [selecteduser, setuser] = useState('');

   const [workdaysdetails, setworkdaysDetails] = useState({ 'totalworkdays': 0.0, 'absentdays': 0.0, 'score': 0.0 });


   const [selectedmonth, setMonth] = useState(monthyear);
   const [teammembers, setteammembers] = useState([]);
   const [teammemberscomp, setteammemberscomp] = useState([]);
   const [defaultuser, setdefaultuser] = useState('');
   const [clients, setClients] = useState([]);
   const [clientscomp, setClientscomp] = useState([]);
   const [subclientscomp, setsubClientscomp] = useState([]);
   const [allsubclients, setallsubClients] = useState([]);
   const [sublclientloaded, setsubclientstatus] = useState(false);
   const [subtaskscomp, settaskscomp] = useState([]);
   const [timesheetlistcomp, settimesheetlistcomp] = useState([]);
   const [timesheetlists, settimesheetlists] = useState([]);
   const [timesheetliststemp, settimesheetliststemp] = useState([]);
   const [subclientLoader, setSubclientloader] = useState(<></>);
   const [selectedtimesheet, settimesheetid] = useState(null);
   const [deletetoggle, setDeletetoggle] = useState(false);
   const [percentage, setPercentage] = useState('');
   const [percentval, setPercentval] = useState('');
   const [billedminutes, setBilledminutes] = useState(0);
   const [tasks, setTasks] = useState([]);
   const [selectedtask, setSelectedTask] = useState('');
   const [selectedclient, setSelectedClient] = useState('');
   const months = [{ 'label': 'Jan', 'value': '1' }];
   const mycontext = useContext(MyContext);
   const [selectedsubclient, setSelectedsubclientt] = useState('');
   const [selectedsubclientid, setSelectedsubclientid] = useState('');
   const [selectedperiod, setSelectedperiod] = useState('0');

   const [evaluatepercent, setEvaluatepercent] = useState({'client':'','task':'','billedmintes':'','percent':''});


   const addformdata = {
      client: '',
      subclient: '',
      BilledMinutes: '',
      Count: '',
      Minutes: '',
      Remarks: '',
      Task: '',
      WorkFrom: '',
      budget_hours: '',
      date: '0',
      querycount: '',
      remaining_hrs: '',
      subclientid:''
   };
   const [formData, setFormData] = useState(addformdata);

   const [editformData, seteditFormData] = useState({
      client: '',
      subclient: '',
      BilledMinutes: '',
      Count: '',
      Minutes: '',
      Remarks: '',
      Task: '',
      taskid: '',
      WorkFrom: '',
      budget_hours: '',
      date: 0,
      fillingfor: 0,
      querycount: '',
      remaining_hrs: '',
      subclientid:''
   });

   const [errors, setErrors] = useState({});
   const [editerrors, seteditErrors] = useState({});
   const [remainhrsloaded, setremainhrsloaded] = useState(true);
   const [remainloaded, setreminloader] = useState(true);
   const [minutestcount, setminutescount] = useState({ minutes: 0, count: 0,billedminutes:0 });
   const [editoriginalminutes, seteditoriginalminutes] = useState(0);
   const [isdeleted, setisdeleted] = useState('');
   const [isadded, setisadded] = useState(true);
   const [onceposition, setonceposition] = useState(0);



   // One-time init: static data that doesn't change with month/deletion
   useEffect(() => {
      const member = userdata.id;
      setuser(member);
      setdefaultuser(member); // triggers defaultuser effect → getTimesheets
      getmemebers();
      getallclient();
      getTasks();
   }, []);

   // Re-fetch timesheets when month, period changes or after add/edit/delete
   useEffect(() => {
      if (!defaultuser) return;
      getTimesheets({ selectedmonth: selectedmonth, selectedmember: defaultuser });
      setloading(false);
      timesheetService.gettimesheetlistswithperiod({ empid: defaultuser, period: selectedperiod }).then((response) => {
         if (response?.status === 200) {
            settimesheetlists(response.data.data);
         } else {
            settimesheetlists([]);
         }
         setloading(true);
      }).catch(() => {
         settimesheetlists([]);
         setloading(true);
      });
   }, [selectedmonth, isdeleted, selectedperiod, defaultuser]);

   useEffect(() => {
      counterfunction();
   }, [timesheetlists]);


   useEffect(()=>{
      setPercentage(0); 
      setPercentval(0); 
      setSelectedTask('');
      setBilledminutes(0);
      setFormData((prevData) =>{
          return{
              ...prevData,
              budget_hours:0,
              remaining_hrs:0,
          }
      });
   },[mycontext.addtimesheettoggle])

   function getallclient() {
      try {
         let emparr = [];
         timesheetService.getallclient().then((response) => {
            setClients(response.data.data);
            response.data.data.forEach((value, index) => {
               if (value.client != '') {
                  emparr.push((<option key={index} value={value.client}>{value.client}</option>));
               }
            });
            setClientscomp(emparr);
         }).catch((error) => {
            // console.log(error);  
         });
      } catch (error) {
         // console.log(error); 
      }
   }

   function getallsubclients({ client }) {
      try {
         let emparr = [];
         setreminloader(false);
         setSubclientloader((<Smallloader />));

         return timesheetService.getallsubclienttemp({ client: client }).then((response) => {
            if (response == undefined || response == '' || response.data.data == undefined) {
               return;
            }
            // console.log('response subclient');
            // console.log(response);
            response.data.data.forEach((value, index) => {
               emparr.push((<option key={index} id={value.id} value={value.subclient}>{value.subclient}</option>));
            });
            setsubClientscomp(emparr);
            setSubclientloader((<></>));
            setallsubClients(response.data.data);
            setreminloader(true);
            return response.data.data;
         }).catch((error) => {
            // console.log(error);  
            setSubclientloader((<></>));
            setreminloader(true);
         });
      } catch (error) {
         // console.log(error);
      }
   }

   function getTasks() {
      let emparr = [];
      timesheetService.gettasks().then((response) => {
         // console.log('get tasks');
         // console.log(response);
         setTasks(response.data.data);
         response.data.data.forEach((value, index) => {
            emparr.push((<option key={index} value={value.id}>{value.name}</option>));
         });
         //  setClientscomp(emparr);
         settaskscomp(emparr);
      }).catch((error) => {
         // console.log(error);  
      });
   }

   function getmemebers() {
      let emparr = [];
      let member = userdata.id;
      timesheetService.getteammembers({ managerid: member }).then((response) => {
         setteammembers(response.data.data);
         response.data.data.forEach((value, index) => {
            emparr.push((<option key={index} value={value.id}>{value.name}</option>));
         });

         setteammemberscomp(emparr);
      }).catch((error) => {
         // console.log(error);
      });
   }
   function getTimesheets({ selectedmonth, selectedmember }) {
      try {
         let member = selectedmember;
         let onceposition = 0;
         setloading(false);
         timesheetService.gettimesheet({ month: selectedmonth, member: member }).then((response) => {
            console.log("response data");
            // console.log(response.status);
            if (response.status == 200) {
               let monarr = [];
               let tuearr = [];
               let wedarr = [];
               let thurarr = [];
               let friarr = [];
               let satarr = [];
               let sunarr = [];

               setworkdaysDetails({ 'totalworkdays': response.data.totalworkdays, 'absentdays': response.data.absentdays, 'score': response.data.score });
               let currentposition = 0;
               let monday = 0;
               let tuesday = 0;
               let wednesday = 0;
               let thursday = 0;
               let friday = 0;
               let satday = 0;
               let sunday = 0;

               // Pre-group by Day+Date to detect dates that carry both status 0 and 1
               const _statusMap = {};
               response.data.data.forEach((el) => {
                  const key = `${el.Day}_${el.Date}`;
                  if (!_statusMap[key]) {
                     _statusMap[key] = { ...el, allStatuses: [] };
                  }
                  if (!_statusMap[key].allStatuses.includes(el.status)) {
                     _statusMap[key].allStatuses.push(el.status);
                  }
               });
               // Deduplicated list preserving original order
               const _seen = new Set();
               const processedData = [];
               response.data.data.forEach((el) => {
                  const key = `${el.Day}_${el.Date}`;
                  if (!_seen.has(key)) {
                     _seen.add(key);
                     processedData.push(_statusMap[key]);
                  }
               });

               const renderCell = (element) => {
                  const isMixed = element.allStatuses.includes(0) && element.allStatuses.includes(1);
                  return isMixed
                     ? getMixedElement(element.Date, element)
                     : getElement(element.allStatuses[0], element.Date, element);
               };

               processedData.forEach((element, index) => {
                  if (element.Day == 'Monday') {
                     if (element.Date == 1) {
                        onceposition = 1;
                     } else {
                        currentposition = 1;
                     }
                     // console.log(onceposition, 'onceposition');
                     // console.log(currentposition, 'currentposition');
                     let counter = monday++;
                     if (element.Date != 1 && (currentposition < onceposition)) {
                        if (counter == 0) {
                           monarr.push(<div></div>);
                        }
                     }
                     monarr.push(renderCell(element));
                  }

                  if (element.Day == 'Tuesday') {
                     if (element.Date == 1) {
                        onceposition = 2;
                     } else {
                        currentposition = 2;
                     }
                     let counter = tuesday++;
                     if (element.Date != 1 && (currentposition < onceposition)) {
                        if (counter == 0) {
                           tuearr.push(<div></div>);
                        }
                     }
                     tuearr.push(renderCell(element));
                  }

                  if (element.Day == 'Wednesday') {
                     if (element.Date == 1) {
                        onceposition = 3;
                     } else {
                        currentposition = 3;
                     }
                     let counter = wednesday++;
                     if (element.Date != 1 && (currentposition < onceposition)) {
                        if (counter == 0) {
                           wedarr.push(<div></div>);
                        }
                     }
                     wedarr.push(renderCell(element));
                  }

                  if (element.Day == 'Thursday') {
                     if (element.Date == 1) {
                        onceposition = 4;
                     } else {
                        currentposition = 4;
                     }
                     let counter = thursday++;
                     if (element.Date != 1 && (currentposition < onceposition)) {
                        if (counter == 0) {
                           thurarr.push(<div></div>);
                        }
                     }
                     thurarr.push(renderCell(element));
                  }

                  if (element.Day == 'Friday') {
                     if (element.Date == 1) {
                        onceposition = 5;
                     } else {
                        currentposition = 5;
                     }
                     let counter = friday++;
                     if (element.Date != 1 && (currentposition < onceposition)) {
                        if (counter == 0) {
                           friarr.push(<div></div>);
                        }
                     }
                     friarr.push(renderCell(element));
                  }

                  if (element.Day == 'Saturday') {
                     if (element.Date == 1) {
                        onceposition = 6;
                     } else {
                        currentposition = 6;
                     }
                     let counter = satday++;
                     if (element.Date != 1 && (currentposition < onceposition)) {
                        if (counter == 0) {
                           satarr.push(<div></div>);
                        }
                     }
                     satarr.push(renderCell(element));
                  }

                  if (element.Day == 'Sunday') {
                     if (element.Date == 1) {
                        onceposition = 7;
                     } else {
                        currentposition = 7;
                     }
                     let counter = sunday++;
                     if (element.Date != 1 && (currentposition < onceposition)) {
                        if (counter == 0) {
                           sunarr.push(<div></div>);
                        }
                     }
                     sunarr.push(renderCell(element));
                  }
               });
               //  console.log('monday data');
               setdays({ mon: monarr, tue: tuearr, wed: wedarr, thur: thurarr, fri: friarr, sat: satarr, sun: sunarr });
               setloading(true);
               setgridloading(true);
               setonceposition(onceposition);

            } else {
               setdays({ mon: [], tue: [], wed: [], thur: [], fri: [], sat: [], sun: [] });
               setgridloading(false);

            }
         }).catch((error) => {

            setloading(true);
            setgridloading(false);

         });
      } catch (error) {
         console.log(error);
      }

   }

   const accept = ({ id }) => {
      deletetimesheet({ id });
   }

   const reject = () => {
      toast.current.show({ severity: 'warn', summary: 'Timesheet', detail: 'Canceled', life: 3000 });
   }

   const confirmdelete = ({ id }) => {
      // console.log(id);
      confirmDialog({
         message: 'Are you sure you want to proceed?',
         header: 'Confirmation',
         icon: 'pi pi-exclamation-triangle',
         defaultFocus: 'accept',
         accept: () => accept({ id }),
         //  accept,
         reject
      });
   };

   function deletetimesheet({ id }) {
      try {
         timesheetService.deletetimesheet({ id: id }).then((response) => {
            if (response.status == 200) {
               let message = response.data.data;
               gettimesheetlists({ userid: selecteduser });
               toast.current.show({ severity: 'success', summary: 'Timesheet', detail: message, life: 3000 });
               let member = userdata.id;
               getTimesheets({ selectedmonth: selectedmonth, selectedmember: member });
               setisdeleted("deleted");

            } else {
               toast.current.show({ severity: 'error', summary: 'Timesheet', detail: 'Not deleted', life: 3000 });
            }
         }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Timesheet', detail: 'Something went wrong', life: 3000 });
         });
      } catch (error) {
         //   console.log(error);
      }
   }

   const getElement = (status, date = null, obj) => {
      try {
         let element;
         let _status = status.toString();
         switch (_status) {
            case '0':
               //element = (<tr><td onClick={() => setVisibility({ date: date })} className='approved-style'>{date}</td></tr>);
               element = (<div onClick={() => setVisibility({ date: date })} className='approved-style'>{date}</div>);
               break;
            case '1':
               // element = (<tr><td className='filled-style'>{date}</td></tr>);
               element = (<div onClick={() => setVisibility({ date: date })} className='filled-style'>{date}</div>);
               break;
            case '3':
               // element = (<tr><td className='dayssat-style'>{date}</td></tr>);
               element = (<div className='dayssat-style' onClick={() => setVisibility({ date: date })}>{date}</div>);
               break;
            default:
               // element = (<tr><td>{date}</td></tr>);
               element = (<div>{date}</div>);
         }
         return element;
      } catch (error) {

      }
   }

   const getMixedElement = (date, obj) => {
      return (
         <div
            onClick={() => setVisibility({ date: date })}
            style={{
               background: 'linear-gradient(135deg, rgb(11,148,23) 50%, #ffffff 50%)',
               cursor: 'pointer',
               color: 'black',
               fontWeight: 600,
               position: 'relative',
               border: '2px solid #eb9a06',
               boxSizing: 'border-box',
            }}
         >
            {date}
         </div>
      );
   }

   // useEffect(()=>{
   //    console.log('Input value changed:', defaultuser);
   //    setUserid(defaultuser);
   // },[defaultuser]);

   function setVisibility({ date }) {
      try {

         let selecteddate = selectedmonth + '-' + date;
         setDate(date);
         setVisible(!visible);
         setsingleloading(false);

         let dataarr = [];
         // let member = userdata.id;
         let member = defaultuser;

         timesheetService.getSingletimesheet({ date: selecteddate, user: member }).then((response) => {
             
             console.log("get single timesheet");
            if(response.status == 200){
                 let object = response.data.data;
                  //  console.log(object);
                  object.forEach((value, index) => {
                     // console.log(value);
                     dataarr.push((<tr>
                        <td scope="col">#</td>
                        <td scope="col">{value.client}</td>
                        <td scope="col">{value.subclient}</td>
                        <td scope="col">{value.hours}</td>
                        <td scope="col">{value.billedhours}</td>
                        <td scope="col"><div style={{width:'200px',overflowWrap: 'break-word'}}>{value.remarks}</div></td>
                        <td scope="col" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                           {value.status != null ? (
                              <FaCheck style={{ color: '#0b9417', fontSize: '16px' }} title="Verified" />
                           ) : null}
                        </td>
                     </tr>));
                  });

                  let totalminute = response.data.total_minutes;
                  let totalbilledminute = response.data.total_billed_minutes;

                  dataarr.push((<tr>
                     <td scope="col">#</td>
                     <td scope="col"></td>
                     <td scope="col" style={{ color: 'red' }}>Total Minutes</td>
                     <td scope="col" style={{ color: 'red' }}>{totalminute}</td>
                     <td scope="col" style={{ color: 'red' }}>{totalbilledminute}</td>
                     <td scope="col"></td>
                     <td scope="col"></td>
                  </tr>));

                  settimesheetData(dataarr);
                  setsingleloading(true);
            }else{
                 settimesheetData([]);
                 setsingleloading(true);
            }
         }).catch((error) => {
            // console.log(error);
            setsingleloading(true);
         });
      } catch (error) {
         // console.log(error);
      }

   }

   const monthChanged = (value) => {
      // console.log(value.target.value);
      setMonth(value.target.value);
      getTimesheets({ selectedmonth: value.target.value, selectedmember: defaultuser });
   }

   function userChanged(event) {
      setdefaultuser(event.target.value);
      // getTimesheets({ selectedmonth: selectedmonth, selectedmember: event.target.value });
   }

   useEffect(()=>{
      console.log("default user");
      console.log(defaultuser);
      getTimesheets({ selectedmonth: selectedmonth, selectedmember: defaultuser })
   },[defaultuser])

   const handleChange = (e) => {
      const { name, id,value } = e.target;
      setFormData((prevData) => ({
         ...prevData,
         [name]: value,
      }));
      let selected_client = '';
      if (name == 'client') {
         //   setSelectedCateg(value);
         selected_client = value;
         setSelectedClient(value);
         getallsubclients({ client: selected_client });

         if(shouldcalculate(selectedtask)){
            getPercentage(selected_client);      
         }else{
            filterdata(tasks,selectedtask);
         }
      }

      if (name == 'subclient') {
         if (!value) return;
         let subclientobj = allsubclients[e.target.selectedIndex - 1];
         setFormData((prevData) => {
              return {
                   ...prevData,
                   subclientid:subclientobj.id
              }
         });
         // setSelectedsubclientid(subclientobj.id);
         setSelectedsubclientt(value);
         getremaining_hrs({ clientid: formData.client, subclientid: value, ftype: 'add',date:formData.date });
      }

      if(name == 'BilledMinutes'){
         //   console.log(value);
           setBilledminutes(value);
           let percent = calculatepercent(value,percentage);
           setPercentval(percent);
      }

      if(name == 'Task'){
         setSelectedTask(value);
         filterdata(tasks,value);
      }
  };

   useEffect(()=>{
      getremaining_hrs({clientid:formData.client,subclientid:formData.subclient,ftype:'add',date:formData.date});
   },[formData.date]);

   useEffect(()=>{
      filterdata(tasks,selectedtask); 
      console.log("form data");
      console.log(formData.date);
      getremaining_hrs({clientid:formData.client,subclientid:formData.subclient,ftype:'add',date:formData.date}); 
   },[selectedsubclient])

   const filterdata = (tasks,value) =>{
      let isexeute = false;
      if (tasks && Array.isArray(tasks)) {
            const found = tasks.some((innerval) => {
               if ((innerval.id == value && innerval.name == "External Amendment") || 
                  (innerval.id == value && innerval.name == "Personal Tax return") ||
                  (innerval.id == value && innerval.name == "Service Charge Accounts") ||
                  (innerval.id == value && innerval.name == "Management Accounts") ||
                  selectedsubclient == 'Admin Hours' || selectedsubclient == 'Admin'
                  ) {
                  
                  let percent = calculatepercent(billedminutes, 100);
                  setPercentval(percent);
                  setPercentage(100); 
                  isexeute = false;
                  return true;  // Stop the loop early
               }
               return false;
            });
            
            if (!found) {
               isexeute = true;
            }

            if(isexeute){
               getPercentage(selectedclient,{value:billedminutes});
            }
     }
   //   else{
   //       console.error('error');
   //   }
   }

   function shouldcalculate(task){
        if(task == '' || task == undefined){
            return true;
        }else{
            return false;
        }
   }

   const getPercentage = (client,{value} = {}) => {
      timesheetService.getparticularpercentage(client).then((response) => {
         if (response.status == 200) {
            // if(value != undefined){
               let percent = calculatepercent(value,response.data.data.percentage);
               setPercentval(percent);
               setPercentage(response.data.data.percentage);    
            // }
         } else {
            setPercentage('');
         }
      }).catch((error) => {
         setPercentage();
      })
   }

   const getremaining_hrs = ({ clientid, subclientid, ftype,date }) => {
      setremainhrsloaded(false);
      setreminloader(false);
      setSubclientloader((<Smallloader />));
      if (ftype == 'add') {
         setFormData((prevData) => ({
            ...prevData,
            budget_hours: '',
            remaining_hrs: ''
         }));
      } else {
         seteditFormData((prevData) => ({
            ...prevData,
            budget_hours: '',
            remaining_hrs: ''
         }));
      }

      timesheetService.getremaining_hrs({ clientid, subclientid,date }).then((response) => {
         let budget_hours = response.data.budget_hours;
         let remaining_hours = response.data.remaining_hours;

         if (ftype == 'add') {
            setFormData((prevData) => ({
               ...prevData,
               budget_hours: budget_hours,
               remaining_hrs: remaining_hours
            }));
         } else {
            seteditFormData((prevData) => ({
               ...prevData,
               budget_hours: budget_hours,
               remaining_hrs: remaining_hours
            }));
         }
         setremainhrsloaded(true);
         setreminloader(true);
         setSubclientloader((<></>));
      }).catch((error) => {
         //   console.log(error);  
         setremainhrsloaded(true);
         setSubclientloader((<></>));
      })
   }

   const validateForm = () => {
      let valid = true;
      const newErrors = {};

      if (!formData.client.trim()) {
         newErrors.client = 'Client is required';
         valid = false;
      }

      if (!formData.subclient.trim()) {
         newErrors.subclient = 'SubClient is required';
         valid = false;
      }

      if (!formData.Minutes.trim()) {
         newErrors.Minutes = 'Actual hours is required';
         valid = false;
      }

      if (!formData.Task.trim()) {
         newErrors.Task = 'Task is required';
         valid = false;
      }

      if (!formData.WorkFrom.trim()) {
         newErrors.WorkFrom = 'Work From is required';
         valid = false;
      }

      if (!formData.date.trim()) {
         newErrors.date = 'Date is required';
         valid = false;
      }

      if (!formData.Remarks.trim()) {
         newErrors.Remarks = 'Remarks is required';
         valid = false;
      }

      setErrors(newErrors);
      return valid;
   };
   const validateeditForm = () => {
      let valid = true;
      const newErrors = {};

      if (!editformData.client.trim()) {
         newErrors.client = 'Client is required';
         valid = false;
      }

      if (!editformData.subclient.trim()) {
         newErrors.subclient = 'SubClient is required';
         valid = false;
      }


      if (!editformData.Minutes) {
         newErrors.Minutes = 'Actual hours is required';
         valid = false;
      }



      if (!editformData.taskid) {
         newErrors.Task = 'Task is required';
         valid = false;
      }

      if (!editformData.WorkFrom.trim()) {
         newErrors.WorkFrom = 'Work From is required';
         valid = false;
      }

      // if (!editformData.date) {
      //    newErrors.date = 'Date is required';
      //    valid = false;
      //  }


      if (!editformData.Remarks.trim()) {
         newErrors.Remarks = 'Remarks is required';
         valid = false;
      }

      seteditErrors(newErrors);
      return valid;
   };

   const handleSubmit = (e) => {
      e.preventDefault();

      // console.log("form data");
      // console.log(formData);
      // return;
      if (validateForm()) {
         addtimesheet({ formdata: formData });
      }
      // Now you can perform any further actions with the form data
   };

   function addtimesheet({ formdata }) {
      setisadded(false);
      formdata['qapercentage'] = percentage;
      formdata['qapercentval'] = percentval;

      let formdata_ = JSON.stringify(formdata);
      timesheetService.addtimesheet({ formdata: formdata_ }).then((response) => {
         // console.log("response data");
         // console.log(response);
         if (response.status == 200) {
            toast.current.show({ severity: 'success', summary: "Timesheet", detail: `Timesheet added successfully`, life: 3000, position: "top-center" });
            mycontext.addtimesheettogglefun(false);
            gettimesheetlists({ userid: selecteduser });
            let member = userdata.id;
            getTimesheets({ selectedmonth: selectedmonth, selectedmember: member });
            setFormData(addformdata);
            setisdeleted(true);
            setisadded(true);
         } else {
            toast.current.show({ severity: 'error', summary: "Timesheet", detail: `${response.data.data}`, life: 3000 });
            setFormData(addformdata);
            setisadded(true);
         }

      }).catch((error) => {
         toast.current.show({ severity: 'error', summary: "Timesheet", detail: `Something went wrong!`, life: 3000 });
         setFormData(addformdata);
         setisadded(true);
      });
   }

   function gettimesheetlists({ userid }) {
      let emparr = [];
      setloading(false);
      timesheetService.gettimesheetlists({ empid: userid }).then((response) => {
         if (response.status == 200) {
            settimesheetlists(response.data.data);
            setisdeleted('timesheetgot');
         } else {
            settimesheetlists([]);
            setisdeleted('timesheetgot');
         }
         setloading(true);
      }).catch((error) => {
         // console.log(error);
         settimesheetlists([]);
         setloading(true);
      });
   }

   function counterfunction() {
      try {
         let totalmin = 0;
         let count = 0;
         let billedminutes = 0;

         if (timesheetlists != undefined) {
            // console.log("counter function data lits");
            // console.log(timesheetlists,"timesshet lists");
            timesheetlists.forEach((values) => {
               totalmin = (typeof values.Minutes === 'number' ? values.Minutes : 0) + totalmin;
               count = (typeof values.Count === 'number' ? values.Count : 0) + count;
               billedminutes = (typeof values.BilledMinutes === 'number' ? values.BilledMinutes :  values.BilledMinutes ? parseFloat(values.BilledMinutes) : 0) + billedminutes;
            });

            // console.log(billedminutes,'Billed minutes');

            // settimesheetliststemp(data);
            if (timesheetlists.length <= 0) {
               setminutescount({ minutes: 0, count: 0,billedminutes:0 });
            } else {
               setminutescount({ minutes: totalmin, count: count,billedminutes: billedminutes});
            }
         }
      } catch (error) {
         setminutescount({ minutes: 0, count: 0,billedminutes: 0 });
      }
   }


   function showtimesheetlists() {
      try {
         let emparr = [];
         timesheetlists.forEach((value, index) => {
            emparr.push(<tr>
               <td>{value.ID}</td>
               <td>{value.Date}</td>
               <td>{value.client}</td>
               <td>{value.subclient}</td>
               <td>{value.Task}</td>
               <td>{value.Minutes}</td>
               <td>{value.BilledMinutes}</td>
               <td>{value.Count}</td>
               <td>{value.querycount}</td>
               <td><div style={{width:'200px',overflowWrap: 'break-word'}}>{value.Remarks}</div></td>
               <td>
                  <div className='container-box'>
                      &nbsp;
                     <span><FaEdit className='edit-btn-style custom-cursor-style' style={{ fontSize: '19px' }} onClick={() => edittogglefun({ id: value.ID, obj: value })} /></span>
                     &nbsp;
                     &nbsp;
                     <span><MdDelete className='delete-btn-style custom-cursor-style' style={{ fontSize: '19px' }} onClick={() => { confirmdelete({ id: value.ID }) }} /></span>
                  </div>
               </td>
            </tr>);
         });
         return emparr;
      } catch (error) {
         return (<></>);
      }

   }

   function edittogglefun({ id, obj }) {
      try {
         seteditFormData({ ...obj, WorkFrom: obj.workfrom || '' });
         seteditoriginalminutes(Number(obj.Minutes) || 0);
         setSelectedClient(obj.client);
         setBilledminutes(obj.BilledMinutes);
         if(shouldcalculate(obj.taskid)){
            getPercentage(obj.client,{value:obj.BilledMinutes});   
            // getPercentage(selected_client);      
         }else{
            filterdata(tasks,obj.taskid);
         }


         let objdata = getallsubclients({ client: obj.client });
         setedittoggle(true);

         objdata.then((response) => {
            if (response == undefined || response == '') {
               return;
            }
            let objselected = {};
            response.forEach((value, index) => {
               if (obj.subclient == value.subclient) {
                  objselected = value;
               }
            });

            seteditFormData((prevData) => ({
               ...prevData,
               // budget_hours:objselected.budget_hours,
               // remaining_hrs:objselected.remaining_hrs,
               date: obj.date
            }))


            // console.log("edit object");
            // console.log(obj.date);
            let fillingdate = obj.date;

            getremaining_hrs({ clientid: obj.client, subclientid: objselected.subclient, ftype: 'edit',date:fillingdate });
         });
      } catch (error) {
         // console.log(error);
      }
      // console.log(obj.subclient);
      // console.log(allsubclients);
   }

   function calculatepercentnew({client,task,billedminutes}){
      setEvaluatepercent((prevData) => ({
         ...prevData,
         client: client,
         task: task,
         billedmintes: billedminutes,
         percent: 0
      }));
   }

   const editChange = (e) => {
      const { name, value } = e.target;
      seteditFormData((prevData) => ({
         ...prevData,
         [name]: value,
      }));

      if (name == 'client') {
         //   setSelectedCateg(value);
         let selected_client = value;
         getallsubclients({ client: selected_client });
         calculatepercentnew({client:selected_client});
         // if(shouldcalculate(selectedtask)){
         //    getPercentage(selectedclient);      
         // }else{
         filterdata(tasks,selectedtask);
         // }
      }


      if (name == 'subclient') {
         // formData.client;
         // get remainign hours
         let subclientobj = allsubclients[e.target.selectedIndex - 1];
         seteditFormData((prevData) => {
              return {
                   ...prevData,
                   subclientid:subclientobj.id
              } 
         });
         setSelectedsubclientt(value);

         // console.log("edit form data");
         // console.log(editformData.date);
         let filling_date = editformData.date;
         getremaining_hrs({ clientid: editformData.client, subclientid: value,ftype:'edit',date:filling_date});
         calculatepercentnew({subclient:value});
      }

      if(name == 'BilledMinutes'){
         let percent = calculatepercent(value,percentage);
         setPercentval(percent);
         setBilledminutes(value);
         calculatepercentnew({billedminutes:value});

         console.log('evaluatepercent');  
         console.log(evaluatepercent);
      }

      if(name == 'taskid'){
         setSelectedTask(value);
         filterdata(tasks,value);
         calculatepercentnew({task:value});
      }
   };

   const editSubmit = (e) => {
      e.preventDefault();
      if (validateeditForm()) {
         updatetimesheet(editformData);
      }
      // Now you can perform any further actions with the form data
   };

   function updatetimesheet(editformData) {
      editformData = JSON.stringify(editformData);
      timesheetService.updatetimesheet({ formdata: editformData }).then((response) => {
         if (response.status == 200) {
            //   console.log(response);
            toast.current.show({ severity: 'success', summary: "Timesheet", detail: `Timesheet Updated successfully`, life: 3000, position: "top-center" });
            setedittoggle(false);
            gettimesheetlists({ userid: selecteduser });
            setisdeleted('updated');
            // console.log('response timeshete');
            // console.log(response.data.flash);
            //counterfunction(timesheetliststemp);
         } else {
            toast.current.show({ severity: 'error', summary: "Timesheet", detail: `${response.data.flash}`, life: 3000 });
         }
      }).catch((error) => {
         toast.current.show({ severity: 'error', summary: "Timesheet", detail: `Something went wrong`, life: 3000 });
      });
   }

   function remainconditioncomp() {
      let obj = {
         'message': (<></>),
         'component': (<input type='number' name='BilledMinutes'  class="form-control" onChange={(e) => handleChange(e)}  step="any"/>),
         'budgethourscomp': (<></>)
      };

      if (formData.remaining_hrs !== '' && parseFloat(formData.remaining_hrs) <= 0) {
         obj.message = (<Message className='custom-width-style' severity="warn" text="Chargeable minutes are not allowed hence the Remaining hours are less or equal to zero." />);
         obj.component = (<input type='number' disabled="true" name='BilledMinutes' class="form-control" onChange={(e) => handleChange(e)} />);
         obj.budgethourscomp = (<></>);
      }
      else if (formData.budget_hours == '' || formData.remaining_hrs == '') {
         obj.message = (<Message className='custom-width-style' severity="error" text="Note : Subclient Budget hours are not available, Chargeable Minutes are not permitted!" />);
         obj.component = (<input type='number' disabled="true" name='BilledMinutes' class="form-control" onChange={(e) => handleChange(e)} />);
         obj.budgethourscomp = (<></>);
         obj.remainhourscomp = (<></>);

      } else if (formData.budget_hours > 0 || formData.remaining_hrs > 0) {
         obj.budgethourscomp = (<div className='col-md-3'>
            <label>Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
            <input type='number' disabled="true" value={formData.budget_hours} name='budget_hours' class="form-control" onChange={(e) => handleChange(e)} />
         </div>);

         obj.remainhourscomp = (<div className='col-md-3'>
            <label>Remaining Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
            <input type='number' disabled="true" value={formData.remaining_hrs} name='remaining_hrs' class="form-control" onChange={(e) => handleChange(e)} />
         </div>);
      }

      if (userdata.project == 'Bookkeeping') {
         let obj = {
            'message': (<></>),
            'component': (<input type='number' name='BilledMinutes' class="form-control" onChange={(e) => handleChange(e)} />),
            'budgethourscomp': (<></>)
         };
         return obj;
      }

      return obj;
   }

   function fillingforcomp() {
      const today = new Date();
      const dayName = today.toLocaleDateString('en-US', { weekday: 'long' });
      let fillingobj = { 'daystr': 'Yesterday', 'dayno': '1' };

      if (dayName == 'Sunday') {
         fillingobj.daystr = 'Friday';
         fillingobj.dayno = '2';
      }
      else if (dayName == 'Monday') {
         fillingobj.daystr = 'Friday';
         fillingobj.dayno = '3';
      } else {
         fillingobj.daystr = 'Yesterday';
         fillingobj.dayno = '1';
      }

      return fillingobj;
   }

   function ischangedfor(e) {
      setSelectedperiod(e.target.value);
   }

   function querycountcomp() {
      let comp = { 'add': (<></>), 'edit': (<></>) };
      if (userdata.project == 'Bookkeeping') {
         comp.add = (<div className='col-md-3'>
            <label>Query Count</label>
            <input type='text' name='querycount' class="form-control" onChange={(e) => handleChange(e)} />
         </div>);

         comp.edit = (<div className='col-md-3'>
            <label>Query Count</label>
            <input type='text' name='querycount' value={editformData.querycount} class="form-control" onChange={(e) => editChange(e)} />
         </div>);
      }
      return comp;
   }

   function percentvalchange(e){
        if(billedminutes != ''){
            let value = e.target.value; 
            let percentage = ((value/billedminutes) * 100).toFixed(2);
            if(percentage <= 100){
               setPercentage(percentage); 
               setPercentval(e.target.value);    
            }
        }
   }

   function displaypercentage(percent) {

   //   console.log(percent);
   //   console.log("percent");
      return (
         userdata.project == 'Year End'?
            (<div className='col-md-6'>
               <br/> 
               <label>QA Percentage</label>
               <br />
               <br />
               <div style={{display:'flex',justifyContent: 'space-between',alignitems: 'center',alignContent: 'stretch',alignItems: 'flex-end'}}>
               <b>Percent : {percentage} %</b>
               &nbsp;
               <span>
               { userdata.roletype == 'QA' ?  (<input type="number" value={percent} onChange={percentvalchange} placeholder='value' className='form-control'/>) : (<input type="number" disabled value={percent} onChange={percentvalchange} placeholder='value' className='form-control'/>) } 
               </span>
              </div>
                  
            </div>) : '');
   }

   

   return (
      <>

         {/* <h4>
         Dashboard
      </h4> */}
         <Toast ref={toast} position="top-center" />
         <div className="invisible-divider-sm"></div>
         <div className='row'>
            <div className='col-md-2'>
               <select className='custom-dropdown-style' onChange={(e) => { monthChanged(e); }}>
                  <option disabled>Select Month</option>
                  {comphelpers.generateFormattedDates(5)}
               </select>
            </div>

            <div className='col-md-2'>
               <select className='custom-dropdown-style' value={defaultuser} onChange={(e) => userChanged(e)}>
                  <option disabled>Select User</option>
                  {teammemberscomp}
                  {/* {comphelpers.generateFormattedDates(5)}  */}
               </select>
            </div>

         </div>
         <div className="invisible-divider-sm"></div>
         {/* <div className="invisible-divider"></div> */}
         <div className="row">
            <div className='col-md-7'>
               <div className='card card-custom-style card-style-padding custom_div'>
                  <div className='row'>
                     <div className='col-md-4'>
                        <div class="card card-custom-style card-1">
                           <div class="card-body">
                              <h5 class="card-title"></h5>
                              <div><h6 class="card-subtitle mb-2 text-muted text-center today">{workdaysdetails.totalworkdays}</h6></div>
                              <p class="card-text today">Workdays</p>
                           </div>
                        </div>
                     </div>
                     <div className='col-md-4'>
                        <div class="card card-custom-style card-2">
                           <div class="card-body">
                              <h5 class="card-title"></h5>
                              <div><h6 class="card-subtitle mb-2 text-muted text-center absent">{workdaysdetails.absentdays}</h6></div>
                              <p class="card-text absent">Not Filled</p>
                           </div>
                        </div>
                     </div>
                     <div className='col-md-4'>
                        <div class="card card-custom-style card-3">
                           <div class="card-body">
                              <h5 class="card-title"></h5>
                              <div><h6 class="card-subtitle mb-2 text-muted score">{workdaysdetails.score}</h6></div>
                              <p class="card-text score">Score</p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>


            </div>
            <div className='col-md-5'>
               <div class="card card-custom-style card-custom-height">
                  <div class="card-body">
                     <div><img src="" /></div>
                     <p class="quote-text-style">“It always seems impossible until it’s done.”</p>
                     <p class="quote-text-style quote-text-style-color">— JAPANESE PROVERB</p>
                     <div><img src="" /></div>
                  </div>
               </div>
            </div>
         </div>
         <div className="invisible-divider"></div>
         <div className='row'>
            {/* add timesheet pop  */}
            <Dialog
               header={
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingRight: '24px' }}>
                     <span>Add Timesheet</span>
                     {/* <span style={{ fontSize: '14px', fontWeight: 600, color: (540 - (Number(minutestcount.minutes) || 0) - (Number(formData.Minutes) || 0)) < 0 ? '#dc2626' : '#16a34a' }}>
                        Remaining Minutes : {540 - (Number(minutestcount.minutes) || 0) - (Number(formData.Minutes) || 0)} min
                     </span> */}
                  </div>
               }
               visible={mycontext.addtimesheettoggle}
               style={{ width: '60vw' }}
               onHide={() => mycontext.addtimesheettogglefun(false)}
            >
               <form onSubmit={handleSubmit}>
                  <div className='col-md-12'>
                     <div className='row'>
                        <div className='col-md-12'>
                           {!remainloaded ? (<span className='pull-right'>{Smallloader()}</span>) : (remainconditioncomp().message)}
                           {/* {remainconditioncomp().message} */}
                           <br />
                           <br />
                           {/* <h2>Note : Subclient Budget hours are not available, Chargeable Minutes are not permitted!</h2> */}
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col-md-6'>
                           <label><Mandate />Select Client</label>
                           <select className='custom-dropdown-style' required name="client" class="form-control" onChange={(e) => handleChange(e)}>
                              <option value="">Select</option>
                              {clientscomp}
                           </select>
                           {errors.client && <span className='error'>{errors.client}</span>}
                        </div>
                        <div className='col-md-6'>
                           <label><Mandate />Select SubClient</label> <span>{subclientLoader}</span>
                           <select className='custom-dropdown-style' id="mySelect" required value={formData.subclient} name="subclient" onChange={(e) => handleChange(e)} class="form-control">
                              <option value="">Select</option>
                              {subclientscomp}
                           </select>
                           {errors.subclient && <span className='error'>{errors.subclient}</span>}

                        </div>
                     </div>
                     <br />

                     <div className='row'>
                        <div className='col-md-3'>
                           <label><Mandate />Task</label>
                           <select className='custom-dropdown-style' required name="Task" onChange={(e) => handleChange(e)} class="form-control">
                              <option>Select</option>
                              {subtaskscomp}
                           </select>
                           {errors.Task && <span className='error'>{errors.Task}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label><Mandate />Work From</label>
                           <select className='custom-dropdown-style' required value={formData.WorkFrom} name="WorkFrom" onChange={(e) => handleChange(e)} class="form-control">
                              <option value="">Select</option>
                               <option value="office">Office</option>
                              <option value="home">Home</option>
                           </select>
                           {errors.WorkFrom && <span className='error'>{errors.WorkFrom}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label><Mandate />Minutes</label>
                           <input type='number' name="Minutes" required class="form-control" onChange={(e) => handleChange(e)} step="any"/>
                           {errors.Minutes && <span className='error'>{errors.Minutes}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label>Chargeable Minutes</label>
                           {remainconditioncomp().component}
                           {/* <input type='number' name='BilledMinutes' class="form-control" onChange={(e) => handleChange(e)}/>   */}
                        </div>
                     </div>
                     <br />
                     <div className='row'>
                        {remainconditioncomp().budgethourscomp}
                        {/* <div className='col-md-3'>
                        <label>Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>  
                        <input type='number' disabled="true" value={formData.budget_hours}  name='budget_hours' class="form-control" onChange={(e) => handleChange(e)}/>
                     </div> */}
                        {remainconditioncomp().remainhourscomp}
                        {/* <div className='col-md-3'>
                        <label>Remaining Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
                        <input type='number' disabled="true" value={formData.remaining_hrs} name='remaining_hrs' class="form-control" onChange={(e) => handleChange(e)}/>  
                     </div> */}
                        <div className='col-md-3'>
                           <label>Count</label>
                           <input type='text' name='Count' class="form-control" onChange={(e) => handleChange(e)} />
                        </div>
                        {querycountcomp().add}
                        {/* <div className='col-md-3'>
                     <label>Query Count</label>
                     <input type='text' name='querycount' class="form-control" onChange={(e) => handleChange(e)}/>  
                     </div> */}

                        <div className='col-md-3'>
                           <label><Mandate />Filling For</label>
                           <select className='custom-dropdown-style' required value={formData.date} name="date" onChange={(e) => handleChange(e)} class="form-control">
                              <option value="0">Today</option>
                              <option value={fillingforcomp().dayno}>{fillingforcomp().daystr}</option>
                           </select>
                           {errors.date && <span className='error'>{errors.date}</span>}
                        </div>

                        <div className='col-md-6'>
                           <br/>
                           <label><Mandate />Remarks</label>
                           <br />  
                           {userdata?.dept != 'IT Support (1009)' ? (<textarea name='Remarks' autocomplete="on" autofocus required onChange={(e) => handleChange(e)} class="form-control"></textarea>) : (<input type="text" name='Remarks' autocomplete="on" autofocus required onChange={(e) => handleChange(e)} class="form-control"/>)} 
                           
                           
                           {/* <input type='text' name='Remarks' onChange={(e) => handleChange(e)} class="form-control"/>   */}
                           {errors.Remarks && <span className='error'>{errors.Remarks}</span>}
                        </div>
                          {displaypercentage(percentval)} 
                        
                     </div>
                     <br />

                     <div className='row'>
                        <div>
                           <div className='pull-right'>
                              <span>
                                 {isadded ? (<Button type="submit" label="Save" severity="success" rounded />) : (<Button type="button" disabled label="Save" severity="success" rounded />)}

                              </span>

                              <span>
                                 <Button type="button" onClick={() => mycontext.addtimesheettogglefun(false)} stype="button" label="Close" severity="danger" rounded />
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </form>
            </Dialog>
            {/* add timesheet pop  */}
            

            {/* edit timesheet pop  */}
            <Dialog
               header={
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingRight: '24px' }}>
                     <span>Edit Timesheet</span>
                     {/* <span style={{ fontSize: '14px', fontWeight: 600, color: (540 - ((Number(minutestcount.minutes) || 0) - editoriginalminutes) - (Number(editformData.Minutes) || 0)) < 0 ? '#dc2626' : '#16a34a' }}>
                        Remaining Minutes : {540 - ((Number(minutestcount.minutes) || 0) - editoriginalminutes) - (Number(editformData.Minutes) || 0)} min
                     </span> */}
                  </div>
               }
               visible={edittoggle}
               style={{ width: '60vw' }}
               onHide={() => setedittoggle(false)}
            >
               <form onSubmit={editSubmit}>
                  <div className='col-md-12'>
                     {editformData.remaining_hrs !== '' && parseFloat(editformData.remaining_hrs) <= 0 && (
                        <div className='row'>
                           <div className='col-md-12' style={{ marginBottom: '10px' }}>
                              <Message className='custom-width-style' severity="warn" text="Chargeable minutes are not allowed hence the Remaining hours are less or equal to zero." />
                           </div>
                        </div>
                     )}
                     <div className='row'>
                        <div className='col-md-6'>
                           <label><Mandate /> Select Client</label>
                           <select className='custom-dropdown-style' required value={editformData.client} name="client" onChange={(e) => editChange(e)} class="form-control" >
                              <option value="">Select</option>
                              {clientscomp}
                           </select>
                           {editerrors.client && <span className='error'>{editerrors.client}</span>}
                        </div>
                        <div className='col-md-6'>
                           <label><Mandate /> Select SubClient</label> <span>{subclientLoader}</span>
                           <select className='custom-dropdown-style' required value={editformData.subclient} name="subclient" onChange={(e) => editChange(e)} class="form-control">
                              <option value="">Select</option>
                              {subclientscomp}
                           </select>
                           {editerrors.subclient && <span className='error'>{editerrors.subclient}</span>}
                        </div>
                     </div>
                     <br />

                     <div className='row'>
                        <div className='col-md-3'>
                           <label><Mandate /> Task</label>
                           <select className='custom-dropdown-style' required value={editformData.taskid} name="taskid" onChange={(e) => editChange(e)} class="form-control">
                              <option value="">Select</option>
                              {subtaskscomp}
                           </select>
                           {editerrors.Task && <span className='error'>{editerrors.Task}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label><Mandate /> Work From</label>
                           <select className='custom-dropdown-style' required value={editformData.WorkFrom} name="WorkFrom" onChange={(e) => editChange(e)} class="form-control">
                              <option value="">Select</option>
                              <option value="office">Office</option>
                              <option value="home">Home</option>
                           </select>
                           {editerrors.WorkFrom && <span className='error'>{editerrors.WorkFrom}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label><Mandate /> Minutes</label>
                           <input type='number' required name='Minutes' value={editformData.Minutes} onChange={(e) => editChange(e)} class="form-control" step="any"/>
                           {editerrors.Minutes && <span className='error'>{editerrors.Minutes}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label>Chargeable Minutes</label>
                           <input type='number' name='BilledMinutes' value={editformData.BilledMinutes} onChange={(e) => editChange(e)} class="form-control" step="any"
                              disabled={editformData.remaining_hrs !== '' && parseFloat(editformData.remaining_hrs) <= 0}
                           />
                        </div>
                     </div>
                     <br />
                     <div className='row'>
                        <div className='col-md-3'>
                           <label>Budget Hours</label> <span>{subclientLoader}</span>
                           <input type='number' disabled="true" value={editformData.budget_hours} name='budget_hours' onChange={(e) => editChange(e)} class="form-control" />
                        </div>
                        <div className='col-md-3'>
                           <label>Remaining Budget Hours</label> <span>{subclientLoader}</span>
                           <input type='number' disabled="true" value={editformData.remaining_hrs} name='remaining_hrs' onChange={(e) => editChange(e)} class="form-control" />
                        </div>
                        <div className='col-md-3'>
                           <label>Count</label>
                           <input type='text' name='Count' value={editformData.Count} onChange={(e) => editChange(e)} class="form-control" />
                        </div>
                        {querycountcomp().edit}
                       
                        <div className='col-md-3'>
                           <label><Mandate /> Filling For</label>
                           <select className='custom-dropdown-style' required disabled="true" value={editformData.date} name="date" onChange={(e) => editChange(e)} class="form-control">
                              <option value="0">Today</option>
                              <option value="1">Yesterday</option>
                           </select>
                           {/* {editerrors.date && <span className='error'>{editerrors.date}</span>} */}
                        </div>

                        <div className='col-md-6'>
                           <label><Mandate /> Remarks</label>
                           <br />
                           {userdata?.dept != 'IT Support (1009)' ? ( <textarea type='text' required name='Remarks' value={editformData.Remarks} onChange={(e) => editChange(e)} class="form-control" />) : (<input type="text" name='Remarks' value={editformData.Remarks} onChange={(e) => editChange(e)} class="form-control"/>)}

                          
                           {editerrors.Remarks && <span className='error'>{editerrors.Remarks}</span>}
                        </div>

                        {displaypercentage(percentval)} 

                     </div>
                     <br />

                     <div className='row'>
                        <div>
                           <div className='pull-right'>
                              <span>
                                 <Button type="submit" label="Save" severity="success" rounded />
                              </span>

                              <span>
                                 <Button type="button" onClick={() => setedittoggle(false)} label="Close" severity="danger" rounded />
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </form>
            </Dialog>
            {/* edit timesheet pop  */}

            <Dialog header="Task" visible={visible} style={{ width: '65vw' }} onHide={() => setVisible(false)}>
               <h3>{statedate}</h3>
               {!issingleloaded ? (loader.Loadermd()) : (<table class="table table-bordered">
                  <thead>
                     <tr>
                        <th scope="col">#</th>
                        <th scope="col">Client</th>
                        <th scope="col">SubClient</th>
                        <th scope="col">Actual Min</th>
                        <th scope="col">Billed Min</th>
                        <th scope="col">Remarks</th>
                        <th scope="col">Verified</th>
                     </tr>
                  </thead>

                  <tbody>
                     {timesheetdata}
                  </tbody>
               </table>)}

            </Dialog>

            <ConfirmDialog />
            <div className='col-md-3'>
               {isgridloaded}
               <div class="card card-custom-style" style={{ background: 'none' }}>

                  {!isloaded ? loader.Loadermd()
                     : !isgridloaded ? (<div className='grid-container-style'>Not found</div>)
                        : (<div className='grid-container-style'>
                           <div className='custom-grid-container'>
                              <div>
                                 <div>MON</div>
                                 {days.mon}
                              </div>
                              <div>
                                 <div>TUE</div>
                                 {days.tue}
                              </div>
                              <div>
                                 <div>WED</div>
                                 {days.wed}
                              </div>
                              <div>
                                 <div>THU</div>
                                 {days.thur}
                              </div>
                              <div>
                                 <div>FRI</div>
                                 {days.fri}
                              </div>
                              <div>
                                 <div>SAT</div>
                                 {days.sat}
                              </div>
                              <div>
                                 <div>SUN</div>
                                 {days.sun}
                              </div>
                           </div>
                        </div>)}
               </div>
            </div>

            <div className='col-md-9'>
               <div className='row'>
                  <div className='col-md-8'>
                     <div className='pagination-style' style={{ height: '100%' }}><span style={{ fontWeight: '800', color: 'rgb(217 122 22)', fontSize: '18px' }}>Total Minutes : {minutestcount.minutes}</span> &nbsp; | &nbsp; <span style={{ fontWeight: '800', color: 'rgb(22 56 217)', fontSize: '18px' }}>Total Billed Minutes : {minutestcount.billedminutes}</span> &nbsp; | &nbsp; <span style={{ fontWeight: '800', color: '#556ee6', fontSize: '18px' }}>Count : {minutestcount.count}</span></div>
                  </div>
                  <div className='col-md-4'>
                     <select className='custom-dropdown-style' value={selectedperiod} onChange={(e) => { ischangedfor(e) }}>
                        <option value="0">Today</option>
                        <option value={fillingforcomp().dayno}>{fillingforcomp().daystr}</option>
                        <option value={new Date().getDay() == '1' ? "4" : "3"}>Both days</option>
                     </select>
                  </div>
               </div>
               <br />

               {!isloaded ? loader.Loadermd() : (
                  <div class="card card-custom-style card-style-padding-sm" style={{borderRadius:'unset !important'}}>
                     <table class="table-bordered custom-table-style">
                        <thead>
                           <tr>
                              <th>Id</th>
                              <th>Date</th>
                              <th>Client</th>
                              <th>Sub Client</th>
                              <th>Task</th>
                              <th>Minutes</th>
                              <th>Billable Minutes</th>
                              <th>Count</th>
                              <th>Query Count</th>
                              <th>Remarks</th>
                              <th>Action</th>
                           </tr>
                        </thead>
                        <tbody>
                           {showtimesheetlists()}
                        </tbody>
                     </table>
                  </div>
               )}

            </div>

         </div>

         <div className="invisible-divider"></div>

         <div className="invisible-divider"></div>

      </>
   );
}
export default Dashboard;